import React from 'react'
import { Col, Row } from "react-bootstrap";
import AdminSideBar from '../../Components/DashboardComponents/AdminSideBar';
import NavBarDashboard from '../../Components/DashboardComponents/NavBarDashboard'
import ManageBiker from '../../Components/ManageBikers/ManageBiker';
import HolidayHistory from '../../Components/ManageBikers/HolidayHistory';
import ModalHoliday from '../../Components/ManageBikers/ModalHoliday';
const ManageBycker = () => {
    return (
        <div>
            <Row className="py-3">
                <Col sm="5" xs="3" md="2" lg="2">
                    <AdminSideBar />
                </Col>
                <Col sm="12" xs="9" className='px-5' md="12" lg="10">
                    <NavBarDashboard />
                    <ManageBiker />
                </Col>
            </Row>
        </div>
    )
}

export default ManageBycker
